<ng-container *ngIf="column">
  <mat-form-field appearance="outline" class="ag-dateinput">
    <input
      #input
      autocomplete="no-autofill"
      matInput
      [ngModel]="currentValue"
      (ngModelChange)="onDateChange($event)"
      [matDatepicker]="picker"
      [placeholder]="placeholder"
    />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
</ng-container>
